import { useInspectionStore } from '../store';
import { InspectionsItems } from '../slices/inspections';

export interface UseInspectionsResult {
  inspections: InspectionsItems;
  loading: boolean;
}

export function useInspections(): UseInspectionsResult {
  const inspections = useInspectionStore.use.inspections();
  const loading = useInspectionStore.use.inspectionsLoading();

  return { inspections, loading };
}
